<style/styles: any>
  .ul {
    margin-left: 1.6em;
    padding-left: 0;
  }

  .ul > li {
    margin-block-end: var(--space--4);
  }

  .textContainer > * + * {
    margin-block-start: 0.8em;
  }
</style>

export interface Input extends Marko.HTML.UL {}

<const/{ class: className, ...attrs }=input>
<ul class=[styles.ul, className] ...attrs/>
